import Vue from '_lib/_vue';
import App from './index.vue';

import { HbLoading } from '@heybox-components/heybox-ui';
Vue.use(HbLoading);

import { HbShareHeader } from '@heybox-components/hb-share-header';
Vue.use(HbShareHeader);

import reportPlugin from '_lib/plugin/heybox-report.js';
Vue.use(reportPlugin);

new Vue({
  render: (h) => h(App),
}).$mount('#app');
